angular.module('app').directive('stdComplete', function() {
    return {
       'restrict': 'E',
        'template': `
            <md-autocomplete  required  
                md-input-name="autocompleteField"  
                md-items="searchItem in $root.util.search(search, searchText)" 
                md-selected-item="main.item[obj]"  
                md-selected-item-change="main.item[fk] = main.item[obj].id"
                data-ng-init="main.handleNewForeignKey(obj, fk)"
                md-min-length="0" 
                md-clear-button="true" 
                md-search-text="searchText" 
                md-item-text="'(' + searchItem.id + ')' + ' ' + searchItem.name"  
                md-require-match  
                md-floating-label="{{ label }}"> 
                <md-item-template> 
                    <span md-highlight-text="ctrl.searchText">({{ searchItem.id }}) {{searchItem.name}}</span> 
                </md-item-template> 
            </md-autocomplete>
        `,
       'scope': {
           'main': '=',
           'search': '@',
           'label': '@',
           'obj': '@',
           'fk': '@?',
       },
        'controller': function($scope) {
            if(!$scope.fk) {
                $scope.fk = $scope.obj + '_id';
            }
        }
    }
});
